import React from 'react';
import TableCell from '@mui/material/TableCell';
import IntlMessages from 'Util/IntlMessages';

const IntlTableCell = props => {
  const { header, className, id, ...prop } = props;
  return (
    <TableCell className={`${header ? 'row-header' : ''} ${className}`} align={'center'} {...prop}>
      {id && <IntlMessages id={id} />}
    </TableCell>
  );
};

export default IntlTableCell;
